import Keycloak from 'keycloak-js'
import store from '@/store'
import router from '@/router'

const keycloakPlugin = {
  install: (app, options) => {
    const keycloak = new Keycloak({
      realm: process.env.VUE_APP_KEYCLOAK_REALM,
      url: process.env.VUE_APP_KEYCLOAK_URL,
      'ssl-required': 'external',
      clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
      'public-client': true,
      'confidential-port': 0
    })
    keycloak.onAuthSuccess = () => {
      store.dispatch('auth/logInWithJwt', keycloak.token)
        .then(() => {
          router.push({ name: 'customers' })
        })
        .catch(error => {
          router.push({ name: 'login', query: { message: error.message } })
        })
    }
    keycloak.onAuthError = function (errorData) {
      router.push({ name: 'login', query: { message: errorData.error_description } })
    }
    app.config.globalProperties.$keycloak = keycloak

    keycloak.init({ checkLoginIframe: false })
  }
}

export default keycloakPlugin
